import { render, staticRenderFns } from "./BrowsersCard.vue?vue&type=template&id=1ae0657a&scoped=true"
import script from "./BrowsersCard.vue?vue&type=script&lang=js"
export * from "./BrowsersCard.vue?vue&type=script&lang=js"
import style0 from "./BrowsersCard.vue?vue&type=style&index=0&id=1ae0657a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae0657a",
  null
  
)

export default component.exports